export default "__VITE_ASSET__87c08300__"